import { ComponentProps } from 'react';
import styled from 'styled-components';

import { Rarity } from '__generated__/globalTypes';
import { ScarcityIcon } from 'atoms/icons/ScarcityIcon';
import { OverlapItems } from 'atoms/ui/OverlapItems';

const StyledOverlapItems = styled(OverlapItems)`
  align-items: initial;
`;

type Props = {
  rarities: Rarity[];
  size?: ComponentProps<typeof ScarcityIcon>['size'];
};

export const Scarcities = ({ rarities, size = 3 }: Props) => {
  return (
    <StyledOverlapItems reverse offset={9}>
      {rarities.map(rarity => (
        <ScarcityIcon key={rarity} rarity={rarity} size={size} />
      ))}
    </StyledOverlapItems>
  );
};
